<template>
    <div>
        <el-autocomplete
                class="inline-input"
                v-model="coin"
                :fetch-suggestions="querySearch"
                placeholder="请输入币种"
                @select="handleSelect"
                @blur="handleSelect"
                clearable/>
    </div>
</template>

<script>
    import './store';
    import {mapActions, mapState} from 'vuex';
    export default {
        name: "coinSelect",
        computed:{...mapState('common',['coins'])},
        props:['coinType'],
        data(){return{coin:''}},
        created() {this.getSupportCoin()},
        methods:{
            ...mapActions('common',['getSupportCoin']),
            querySearch(queryString, cb) {
                let results = queryString ? this.coins.filter(this.createFilter(queryString)) : this.coins;
                // 调用 callback 返回建议列表的数据
                let suggest = [];
                for(let index in results) {
                    suggest.push({'value':results[index]});
                }
                cb(suggest);
            },
            createFilter(queryString) {
                return (coin) => {
                    return (coin.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) {
                this.$emit('value',this.coin)
            },
        },
        watch:{
            coinType(val) {
                this.coin = val;
            }
        },
        mounted() {
            this.coin = this.coinType;
        },

    }
</script>

<style scoped>

</style>
